import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { useSelector, useDispatch } from 'react-redux'

import * as API from '../../../utils/api'

import {
  fetchSubscription,
  getSubscription,
} from '../../../ducks/subscriptions'

import { getOrganization } from '../../../ducks/organizations'

import Card from '../../Shared/Card'
import EmptyState from '../../Shared/EmptyState'
import Button from '../../Shared/Button'

import styles from './Billing.module.css'

const ONE_DAY = 60 * 60 * 24 * 1000

export const Trial = function BillingTrial({ organization }) {
  const currentDate = +new Date()
  const endDate = new Date(organization.trialEndsAt)

  const daysRemaining = Math.max(
    0,
    Math.round((endDate - currentDate) / ONE_DAY)
  )

  return (
    <div>
      <p className="subtitle">
        {`You have ${daysRemaining} days remaining in your trial.`}
      </p>
      <div className={styles.upgradeButton}>
        <Button to="/subscribe" color="grey">
          Upgrade Now
        </Button>
      </div>
    </div>
  )
}

export const Subscription = function BillingSubscription({ subscription }) {
  const endDate = subscription.current_period_end * 1000

  const amountRaw = subscription.plan.amount / 100
  const amount = amountRaw.toFixed(2)

  const planName = amountRaw === 40 ? 'Enterprise' : 'Starter'

  return (
    <div>
      <p className="subtitle">
        {`You are currently subscribed to the ${planName} plan.`}
      </p>
      <p className="subtitle">
        {`Your next bill for $${amount} will be automatically charged on ${moment(
          new Date(endDate)
        ).format('LL')}.`}
      </p>
    </div>
  )
}

export default function BillingSettings({ organizationId }) {
  const [cancelling, setCancelling] = useState(false)
  const dispatch = useDispatch()
  const subscriptionInfo = useSelector(getSubscription(organizationId))
  const organization = useSelector(getOrganization(organizationId))

  useEffect(() => {
    dispatch(fetchSubscription(organizationId))
  }, [dispatch, organizationId])

  const handleCancel = async () => {
    if (
      !window.confirm(
        'Are you sure you want to cancel your subscription?\n\nYour actions may be lost.'
      )
    ) {
      return
    }

    setCancelling(true)

    try {
      await API.cancelSubscription(organizationId)

      window.location.reload()
    } catch (err) {
      window.alert(
        'There was an error cancelling your subscription. Please contact support at support@easybutton.io'
      )
    }

    setCancelling(false)
  }

  if (!subscriptionInfo) {
    return (
      <Card>
        <h2>Billing</h2>
        <EmptyState tight loading />
      </Card>
    )
  }

  const { subscription } = subscriptionInfo

  if (!subscription) {
    return (
      <Card>
        <h2>Billing</h2>
        <Trial organization={organization} />
      </Card>
    )
  }

  const currentDate = +new Date() / 1000

  const activeTrial =
    subscription.trial_end && subscription.trial_end > currentDate

  return (
    <Card>
      <h2>Billing</h2>
      <div className={styles.description}>
        {activeTrial ? (
          <Trial subscription={subscription} />
        ) : (
          <Subscription subscription={subscription} />
        )}
      </div>
      <div className={styles.cancelButton}>
        <Button color="grey" onClick={handleCancel} loading={cancelling}>
          {activeTrial ? 'Cancel Trial' : 'Cancel Subscription'}
        </Button>
      </div>
    </Card>
  )
}
